import ValueObject from './ValueObject';

export default class CustomerId extends ValueObject {
  equals(other) {
    if (!(other instanceof CustomerId)) {
      return false;
    }

    return super.equals(other);
  }

  static fromJSON(json) {
    return new CustomerId(json);
  }
}
